module.exports = __webpack_public_path__ + "static/media/magic_maid_cafe.netent.ad9dcad0.jpeg";